    import React, { useState, useEffect } from 'react';
    import axios from "axios";
    import Table from "react-bootstrap/Table";
    import Container from "react-bootstrap/Container";
    import Button from 'react-bootstrap/Button';
    import DetalleInventario from '../Componentes/Inventario/DetalleInventario';
    import AgregarDescripcion from '../Componentes/Productos/AgregarDescripcion';
    import CrearInventarioModal from '../Componentes/Inventario/AgregarInventario';

    export default function TablaInventarios() {
        const obtenerInventariosURL = "https://invio.datachile.site/Web/Inventarios/ObtenerInventarios.php";  // Cambia la URL por la correcta
        const [inventarios, setInventarios] = useState([]);
        const [empresa_idEmpresa, setEmpresaIdEmpresa] = useState('');
        const [showModal, setShowModal] = useState(false);
        const [inventarioSeleccionado, setInventarioSeleccionado] = useState(null);

        useEffect(() => {
            const userData = JSON.parse(localStorage.getItem('usuario'));
            if (userData && userData.empresa_idEmpresa) {
                setEmpresaIdEmpresa(userData.empresa_idEmpresa);
                getInventarios(userData.empresa_idEmpresa);
            }
        }, []);

        const getInventarios = async (empresaId) => {
            try {
                const response = await axios.post(obtenerInventariosURL, { empresa_idEmpresa: empresaId });
                setInventarios(response.data);
            } catch (error) {
                console.error('Error al obtener inventarios:', error);
            }
        };

        const handleShowModal = (idInventario) => {
            const inventario = inventarios.find(inv => inv.idInventario === idInventario);
            if (inventario) {
                setInventarioSeleccionado(inventario);
                setShowModal(true);
            }
        };

        const handleCloseModal = () => {
            setShowModal(false);
            setInventarioSeleccionado(null);
        };

        return (
            <Container maxWidth="sm">
                <h2 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Gestión de Inventarios</h2>
                <div className="table-responsive">
                    <CrearInventarioModal />
                    <Table striped bordered hover size="sm" className="table-sm">
                        <thead>
                            <tr>
                                <th scope="col">Inventario</th>
                                <th scope="col">Código Inventario</th>
                                <th scope="col">Fecha de Creación</th>
                                <th scope="col">Lugares Inventariados</th>
                                <th scope="col">Productos Inventariados</th>
                                <th scope="col">Estado</th>
                                <th scope="col">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inventarios.length > 0 ? (
                                inventarios.map((inventario) => (
                                    <tr key={inventario.idInventario}>
                                        <td className='centrar'>{inventario.inventario}</td>
                                        <td className='centrar'>{inventario.codigoInventario}</td>
                                        <td className='centrar'>{inventario.fecha_creacion}</td>
                                        <td className='centrar'>{inventario.lugares_inventariados}</td>
                                        <td className='centrar'>{inventario.productos_inventariados}</td>
                                        <td className='centrar'>{inventario.estado}</td>
                                        <td style={{ display: 'flex', gap: '10px' }}>
                                            <Button variant="primary" size="sm" onClick={() => handleShowModal(inventario.idInventario)}>
                                                Ver
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No hay inventarios disponibles</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {inventarioSeleccionado && (
                    <DetalleInventario
                        show={showModal}
                        handleClose={handleCloseModal}
                        inventario={inventarioSeleccionado}
                    />
                )}
            </Container>
        );
    }
